<template>
  <UsageExample v-model="tab" :code="code" :tabs="tabs" :script="script">
    <v-container class="d-flex flex-column ga-3">
      <v-row>
        <v-col>
          <v-card elevation="4">
            <v-card-title class="font-weight-bold">Default</v-card-title>
            <v-card-text class="d-flex ga-3 flex-wrap">
              <v-layout>
                <HxNavbarV2
                  id="navbar-id"
                  v-model:is-toggled="isToggled"
                  v-model:search-text="searchText"
                  title="Menu Title"
                  :breadcrumbs-items="showBreadcrumbItems"
                  :header="header"
                  enable-draft-mode="Enable Draft Mode"
                  :navbar-items="filteredNavbarItems"
                  :order="order"
                  @title-click="titleClick"
                  @breadcrumb-back-btn-click="breadcrumbBackBtnClick"
                  @update:is-toggled="toggled"
                  @navbar-item-left-icon-click="navitemLeftIconClick"
                  @navbar-item-right-icon-click="navitemRightIconClick"
                >
                  <template #leftIcon="{ index }">
                    <v-icon
                      v-for="(icon, iconIndex) in [
                        'mdi-help-circle-outline',
                        'mdi-help-box-outline'
                      ].slice(0, numberOfLeftIcon > 1 ? numberOfLeftIcon - 1 : 0)"
                      :key="iconIndex"
                      :icon="icon"
                      @click.stop="navitemLeftIconsClick(index, iconIndex)"
                    ></v-icon>
                  </template>
                  <template #rightIcon="{ index }">
                    <hx-chip v-if="showChip" color="red" label="2" />
                    <v-icon
                      v-if="showDotsIcon"
                      icon="mdi-dots-vertical"
                      @click.stop="navitemRightIconsClick(index)"
                    ></v-icon>
                  </template>
                </HxNavbarV2>
                <v-main style="height: 500px">
                  <v-container class="pa-0">
                    <v-sheet
                      color="#f4f5f6"
                      height="450"
                      rounded="lg"
                      border="dashed md"
                      class="pa-4 mx-2"
                    >
                      <p>
                        Breadcrumb:
                        <br />

                        <v-list-item-title
                          v-for="(breadcrumb, index) in showBreadcrumbItems"
                          :key="index"
                        >
                          {{ index + 1 }}:{{ breadcrumb.text }}
                        </v-list-item-title>
                      </p>
                      <p>
                        Header:
                        <br />
                        {{ header }}
                      </p>
                    </v-sheet>
                  </v-container>
                </v-main>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <template #configuration>
      <div class="d-flex flex-column mt-16">
        <v-select v-model="selectedValue" :items="[1, 2, 3, 4, 5]" label="Items" class="ma-2" />
        <v-select
          v-model="numberOfLeftIcon"
          :items="[0, 1, 2, 3]"
          label="Left Icons"
          class="ma-2"
        />
        <v-select
          v-model="navbarItemsDisplay"
          :items="[1, 2, 3, 4, 5]"
          label="Number of Navbar Items"
          class="ma-2"
        />
        <hx-checkbox v-model="showChip" label="Show Chip" class="ma-2" />
        <hx-checkbox v-model="showDotsIcon" label="Show Dots" class="ma-2" />
        <hx-checkbox
          v-model="isAscendingOrder"
          :label="`Sorting: ${order}`"
          class="ma-2"
          @update:model-value="(value) => (order = value ? 'asc' : 'desc')"
        />
      </div>
    </template>
  </UsageExample>
</template>

<script>
import UsageExample from '@/components/helix/utils/UsageExample';

export default {
  name: 'HelixNavbarV2',
  components: { UsageExample },
  setup() {
    const code = `
  <HxNavbarV2
            id="navbar-id"
            v-model:is-toggled="isToggled"
            v-model:search-text="searchText"
            title="Menu Title"
            :breadcrumbs-items="showBreadcrumbItems"
            :header="header"
            enable-draft-mode="Enable Draft Mode"
            :navbar-items="filteredNavbarItems"
            :order="order"
            @title-click="titleClick"
            @breadcrumb-back-btn-click="breadcrumbBackBtnClick"
            @update:is-toggled="toggled"
            @navbar-item-left-icon-click="navitemLeftIconClick"
            @navbar-item-right-icon-click="navitemRightIconClick"
      >
    <template #leftIcon="{ index }">
      <v-icon icon="mdi-help-circle-outline" @click.stop="navitemLeftIconsClick(index)" />
      insert component
    </template>
    <template #rightIcon="{ index }">
      <v-icon icon="mdi-help-circle-outline" @click.stop="navitemRightIconsClick(index)" />
      insert component
    </template>
  </HxNavbarV2>
    `;
    const script = `
export default {
  data() {
    return {
      navbarItems: [
        {
          text: 'Dashboard',
          leftIcon: 'mdi-view-dashboard',
          rightIcon: 'mdi-chevron-right',
          href: 'https://www.google.com',
          target: '_blank',
          children: [
            {
              text: 'Analytics',
              leftIcon: 'mdi-chart-line',
              rightIcon: 'mdi-chevron-right',
              children: [
                {
                  text: 'Sales',
                  leftIcon: 'mdi-cash',
                  rightIcon: 'mdi-chevron-right'
                },
                {
                  text: 'Traffic',
                  leftIcon: 'mdi-traffic-light',
                  rightIcon: 'mdi-chevron-right'
                }
              ]
            },
            {
              text: 'Reports',
              leftIcon: 'mdi-file-chart',
              rightIcon: 'mdi-chevron-right',
              children: [
                {
                  text: 'Monthly',
                  leftIcon: 'mdi-calendar',
                  rightIcon: 'mdi-chevron-right'
                },
                {
                  text: 'Yearly',
                  leftIcon: 'mdi-calendar-range',
                  rightIcon: 'mdi-chevron-right'
                }
              ]
            }
          ]
        },
        // ... other navbar items
      ],
    }
  },
  computed: {
    currentPageLevel() {
      return this.breadcrumbsItems.slice(0, this.selectedValue);
    },
    showBreadcrumbItems() {
      return this.currentPageLevel.slice(0, -1);
    },
    header() {
      return this.currentPageLevel.length > 1
        ? this.currentPageLevel.map((item) => item.text).slice(-1)[0]
        : undefined;
    }
  },
  methods: {
    toggled(value) {
      console.log('HxNavbarV2 toggled:', value);
    },
    titleClick() {
      console.log('HxNavbarV2 title clicked');
    },
    breadcrumbBackBtnClick() {
      console.log('HxNavbarV2 breadcrumb back button clicked:');
    },
    navitemLeftIconClick(index) {
      console.log('HxNavbarV2 navitem left icon clicked:', index);
    },
    navitemLeftIconsClick(index) {
      console.log('HxNavbarV2 left icons clicked:', index);
    },
    navitemRightIconClick(index) {
      console.log('HxNavbarV2 navitem right icon clicked:', index);
    },
    navitemRightIconsClick(index) {
      console.log('HxNavbarV2 right icons clicked:', index);
    }
  }
};
    `;
    return { code, script };
  },
  data() {
    return {
      tab: 'Navbar Usage',
      tabs: ['Navbar Usage'],
      drawer: true,
      breadcrumbsItems: [
        {
          text: 'Home',
          key: 'Home',
          to: '/'
        },
        {
          text: 'Student Duty of Care',
          key: 'Student Duty of Care',
          to: '/'
        },
        {
          text: 'Executive Summary',
          key: 'Executive Summary',
          to: '/module/276/page/ReadMe.md'
        },
        {
          text: 'Contextualisation Guide',
          key: 'Contextualisation Guide',
          to: '/module/276/page/abc.md'
        },
        {
          text: 'Contextualisation Questions',
          key: 'Contextualisation Questions',
          to: '/module/276/page/bcd.md'
        }
      ],
      rail: true,
      selectedValue: 5,
      isToggled: false,
      currentLevel: [],
      currentIndex: 0,
      searchText: '',
      numberOfLeftIcon: 0,
      navbarItemsDisplay: 3,
      showChip: false,
      showDotsIcon: false,
      isAscendingOrder: true,
      order: 'asc',
      navbarItems: [
        {
          text: 'Dashboard',
          leftIcon: 'mdi-view-dashboard',
          rightIcon: 'mdi-chevron-right',
          children: [
            {
              text: 'Analytics',
              leftIcon: 'mdi-chart-line',
              rightIcon: 'mdi-chevron-right',
              children: [
                {
                  text: 'Sales',
                  leftIcon: 'mdi-cash',
                  rightIcon: 'mdi-chevron-right'
                },
                {
                  text: 'Traffic',
                  leftIcon: 'mdi-traffic-light',
                  rightIcon: 'mdi-chevron-right'
                }
              ]
            },
            {
              text: 'Reports',
              leftIcon: 'mdi-file-chart',
              rightIcon: 'mdi-chevron-right',
              children: [
                {
                  text: 'Monthly',
                  leftIcon: 'mdi-calendar',
                  rightIcon: 'mdi-chevron-right'
                },
                {
                  text: 'Yearly',
                  leftIcon: 'mdi-calendar-range',
                  rightIcon: 'mdi-chevron-right'
                }
              ]
            }
          ]
        },
        {
          text: 'Settings',
          leftIcon: 'mdi-cog',
          rightIcon: 'mdi-chevron-right',
          href: 'https://www.google.com',
          children: [
            {
              text: 'Profile',
              leftIcon: 'mdi-account',
              rightIcon: 'mdi-chevron-right',
              href: 'https://www.google.com',
              target: '_blank',
              children: [
                {
                  text: 'Edit Profile',
                  leftIcon: 'mdi-pencil',
                  rightIcon: 'mdi-chevron-right'
                },
                {
                  text: 'Privacy Settings',
                  leftIcon: 'mdi-lock',
                  rightIcon: 'mdi-chevron-right'
                }
              ]
            },
            {
              text: 'Preferences',
              leftIcon: 'mdi-tune',
              rightIcon: 'mdi-chevron-right',
              href: 'https://www.google.com',
              target: '_self',
              children: [
                {
                  text: 'Notifications',
                  leftIcon: 'mdi-bell',
                  rightIcon: 'mdi-chevron-right'
                },
                {
                  text: 'Language',
                  leftIcon: 'mdi-translate',
                  rightIcon: 'mdi-chevron-right'
                }
              ]
            }
          ]
        },
        {
          text: 'Help',
          leftIcon: 'mdi-help-circle',
          rightIcon: 'mdi-chevron-right',
          children: [
            {
              text: 'FAQ',
              leftIcon: 'mdi-frequently-asked-questions',
              rightIcon: 'mdi-chevron-right',
              children: [
                {
                  text: 'General',
                  leftIcon: 'mdi-information',
                  rightIcon: 'mdi-chevron-right'
                },
                {
                  text: 'Technical',
                  leftIcon: 'mdi-wrench',
                  rightIcon: 'mdi-chevron-right'
                }
              ]
            },
            {
              text: 'Contact Support',
              leftIcon: 'mdi-phone',
              rightIcon: 'mdi-chevron-right',
              children: [
                {
                  text: 'Email',
                  leftIcon: 'mdi-email',
                  rightIcon: 'mdi-chevron-right'
                },
                {
                  text: 'Phone',
                  leftIcon: 'mdi-phone-classic',
                  rightIcon: 'mdi-chevron-right'
                }
              ]
            }
          ]
        },
        {
          text: 'Projects',
          leftIcon: 'mdi-folder',
          rightIcon: 'mdi-chevron-right',
          children: [
            {
              text: 'Active Projects',
              leftIcon: 'mdi-folder-open',
              rightIcon: 'mdi-chevron-right',
              children: [
                {
                  text: 'Project A',
                  leftIcon: 'mdi-alpha-a-box',
                  rightIcon: 'mdi-chevron-right'
                },
                {
                  text: 'Project B',
                  leftIcon: 'mdi-alpha-b-box',
                  rightIcon: 'mdi-chevron-right'
                }
              ]
            },
            {
              text: 'Archived Projects',
              leftIcon: 'mdi-folder-outline',
              rightIcon: 'mdi-chevron-right',
              children: [
                {
                  text: 'Project X',
                  leftIcon: 'mdi-alpha-x-box',
                  rightIcon: 'mdi-chevron-right'
                },
                {
                  text: 'Project Y',
                  leftIcon: 'mdi-alpha-y-box',
                  rightIcon: 'mdi-chevron-right'
                }
              ]
            }
          ]
        },
        {
          text: 'Notifications',
          leftIcon: 'mdi-bell',
          rightIcon: 'mdi-chevron-right',
          children: [
            {
              text: 'Unread',
              leftIcon: 'mdi-email-alert',
              rightIcon: 'mdi-chevron-right',
              children: [
                {
                  text: 'Messages',
                  leftIcon: 'mdi-message',
                  rightIcon: 'mdi-chevron-right'
                },
                {
                  text: 'Alerts',
                  leftIcon: 'mdi-alert',
                  rightIcon: 'mdi-chevron-right'
                }
              ]
            },
            {
              text: 'Read',
              leftIcon: 'mdi-email-check',
              rightIcon: 'mdi-chevron-right',
              children: [
                {
                  text: 'Messages',
                  leftIcon: 'mdi-message-text',
                  rightIcon: 'mdi-chevron-right'
                },
                {
                  text: 'Alerts',
                  leftIcon: 'mdi-alert-circle',
                  rightIcon: 'mdi-chevron-right'
                }
              ]
            }
          ]
        },
        {
          text: 'Users',
          leftIcon: 'mdi-account-group',
          rightIcon: 'mdi-chevron-right',
          children: [
            {
              text: 'Admins',
              leftIcon: 'mdi-account-star',
              rightIcon: 'mdi-chevron-right',
              children: [
                {
                  text: 'Admin A',
                  leftIcon: 'mdi-alpha-a-circle',
                  rightIcon: 'mdi-chevron-right'
                },
                {
                  text: 'Admin B',
                  leftIcon: 'mdi-alpha-b-circle',
                  rightIcon: 'mdi-chevron-right'
                }
              ]
            },
            {
              text: 'Members',
              leftIcon: 'mdi-account',
              rightIcon: 'mdi-chevron-right',
              children: [
                {
                  text: 'Member X',
                  leftIcon: 'mdi-alpha-x-circle',
                  rightIcon: 'mdi-chevron-right'
                },
                {
                  text: 'Member Y',
                  leftIcon: 'mdi-alpha-y-circle',
                  rightIcon: 'mdi-chevron-right'
                }
              ]
            }
          ]
        },
        {
          text: 'Reports',
          leftIcon: 'mdi-file-chart',
          rightIcon: 'mdi-chevron-right',
          children: [
            {
              text: 'Daily Reports',
              leftIcon: 'mdi-calendar-today',
              rightIcon: 'mdi-chevron-right',
              children: [
                {
                  text: 'Summary',
                  leftIcon: 'mdi-file-document',
                  rightIcon: 'mdi-chevron-right'
                },
                {
                  text: 'Details',
                  leftIcon: 'mdi-file-document-outline',
                  rightIcon: 'mdi-chevron-right'
                }
              ]
            },
            {
              text: 'Weekly Reports',
              leftIcon: 'mdi-calendar-week',
              rightIcon: 'mdi-chevron-right',
              children: [
                {
                  text: 'Summary',
                  leftIcon: 'mdi-file-document-box',
                  rightIcon: 'mdi-chevron-right'
                },
                {
                  text: 'Details',
                  leftIcon: 'mdi-file-document-box-outline',
                  rightIcon: 'mdi-chevron-right'
                }
              ]
            }
          ]
        }
      ]
    };
  },
  computed: {
    currentPageLevel() {
      return this.breadcrumbsItems.slice(0, this.selectedValue);
    },
    showBreadcrumbItems() {
      return this.currentPageLevel.slice(0, -1);
    },
    header() {
      return this.currentPageLevel.length > 1
        ? this.currentPageLevel.map((item) => item.text).slice(-1)[0]
        : undefined;
    },
    currentItems() {
      const showItems = this.currentLevel.length > 0 ? this.currentLevel : this.navbarItems;
      const itemsWithRightIcons = showItems.map((item) => {
        return {
          ...item,
          leftIcon: this.numberOfLeftIcon ? item.leftIcon : null,
          rightIcon: item.children && item.children.length > 0 ? item.rightIcon : null
        };
      });
      return itemsWithRightIcons;
    },
    filteredNavbarItems() {
      return this.currentItems
        .filter((item) => {
          return item.text.toLowerCase().includes(this.searchText.toLowerCase());
        })
        .slice(0, this.navbarItemsDisplay);
    }
  },
  methods: {
    toggled(value) {
      console.log('HxNavbarV2 toggled:', value);
    },
    titleClick() {
      console.log('HxNavbarV2 title clicked');
    },
    breadcrumbBackBtnClick() {
      console.log('HxNavbarV2 breadcrumb back button clicked:');
      this.currentLevel = this.navbarItems;
    },
    navitemLeftIconClick(index) {
      console.log('HxNavbarV2 navitem left icon clicked:', index);
    },
    navitemLeftIconsClick(index, iconIndex) {
      console.log('HxNavbarV2 left icons clicked:', index, iconIndex);
    },
    navitemRightIconClick(index) {
      this.searchText = '';
      const item = this.currentItems[index];
      if (this.hasChildren(item)) {
        const childrenMap = Object.values(item.children);
        this.currentLevel = [...childrenMap];
      }
    },
    hasChildren(item) {
      return item && Object.values(item.children).length > 0;
    },
    navitemRightIconsClick(index) {
      console.log('HxNavbarV2 right icons clicked:', index);
    }
  }
};
</script>
